module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("PART III")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title-2"
  }, [_c('span', [_vm._v("THE ARCHIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-a"
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGULATIONS FOR")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SE OF THE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARVARD")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIVERSITY")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RCHIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-n"
  }, [_c('i', [_vm._v("1. The reading room is exclusively for use of Archives materials")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-n"
  }, [_c('i', [_vm._v("2. All material must be handled with care")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-n"
  }, [_c('i', [_vm._v("3. The use of pens is prohibited; only pencils may be used")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-n"
  }, [_c('i', [_vm._v("4. Coats, briefcases, and bags must be left in the closet by the Reference Desk …")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ca28cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part3chapter01.vue
// module id = 99
// module chunks = 0